import React, { useEffect } from "react";
//import { BookingResponse } from "../../../../backend/src/models/bookingDetails";
import StripePayment from "../StripePaymentForm";
import { fetchBookingByReference, getBookingDetails } from "../../api-client";

interface PaymentComponentProps {
    formData: any;
    responseToken: string;
    onUpdate: (data: any) => void;
    onNext: () => void;
    onBack: () => void;
    email?: string;
}

const PaymentComponent: React.FC<PaymentComponentProps> = ({
    formData,
    onUpdate,
    onNext,
    //email,
    //responseToken
  }) => {
    //const [booking, setBooking] = useState<BookingResponse | null>(null);
  
    useEffect(() => {
      const fetchBookingDetails = async () => {
          if (formData.bookingResponse) {
              const details = await getBookingDetails(formData.responseToken ?? formData.bookingResponse);
              //setBooking(details);

              const detailsFromDb = await fetchBookingByReference(details.reference);
              //setBookingFromDB(detailsFromDb);

              // ✅ Ensure `bookingFromDB` is stored in `formData`
              onUpdate((prevData: any) => ({
                  ...prevData, // Keep existing data
                  bookingDetails: details,
                  bookingFromDB: detailsFromDb, // ✅ Add this
              }));
          }
      };

      fetchBookingDetails();
  }, [formData]);
  
  return (
    <div className="mt-4">
      {/* {booking && (formData.leadPassengerEmail ?? email) && ( */}
        <StripePayment
          price={formData.selectedPrice || formData.totalCost} // Ensure a fallback value
          //reference={booking.reference}
          //bookingStatus={booking.bookingStatus}
          responseToken={formData.responseToken}
          //booking={booking}
          passengerEmail={'aadil@haloflights.co.uk'}
          onNext={onNext}
          formData={formData}
          onUpdate={({ bookingResponse, bookingDetails, bookingFromDB }) => {
            //setBooking(bookingDetails);
            //setBookingFromDB(bookingFromDB);
            onUpdate({ bookingResponse, bookingDetails, bookingFromDB });
        }}
        />
      {/* )} */}
    </div>
  );
    
  };
  
  export default PaymentComponent;  
